// Main WIMS backend host. Read from project.config (not Dataman-Backend) because Dataman-Backend imports this file.
import { api as apiConf } from '../../../../project.config';

export const AI_SEARCH_SERVICE_HOST = apiConf.url;

// Custom routes: unlike API Platform resources they have no `.jsonld` variant (404), JSON-LD is asked via Accept.
export const AI_SEARCH_PATHS = {
  ask: `${AI_SEARCH_SERVICE_HOST}/api/ai-ask`,
  plan: `${AI_SEARCH_SERVICE_HOST}/api/ai-plan`,
  history: `${AI_SEARCH_SERVICE_HOST}/api/ai-request-history`,
};
